import { gql } from '@apollo/client';

export const GET_PUSHABLE_CONFIG_ITEMS = gql`
  query GetPushableConfigItems($keys: [String!]) {
    vm {
      configItems(keys: $keys) {
        configItemId
        key
        description
        defaultValue
        configItemValue {
          flagValue
        }
      }
    }
  }
`;
